import React, { useState, useEffect } from 'react';
import './NavBarDropDownMenu.scss';
import { Link } from 'react-router-dom';

export const NavBarDropDownMenu = ({ isActive, itemList }) => {
  const [animationState, setAnimationState] = useState('idle');

  useEffect(() => {
    if (isActive) {
      setAnimationState('opening');
      const timer = setTimeout(() => {
        setAnimationState('active');
      }, 500);
      return () => clearTimeout(timer);
    } else if (animationState !== 'idle') {
      setAnimationState('closing');
      const timer = setTimeout(() => {
        setAnimationState('idle');
      }, 250);
      return () => clearTimeout(timer);
    }
  }, [isActive]);

  const menuClass = `navbar-dropdown-menu ${animationState === 'opening' ? 'opening active' : ''} ${animationState === 'active' ? 'active' : ''} ${animationState === 'closing' ? 'closing' : ''}`;

  return (
    <div className={menuClass}>
      {
        itemList.map((item, i) => {
          return <Link to={item.path} key={i}>
            <div className="navbar-dropdown-menu__item">
              <div className="navbar-dropdown-menu__item__circle" color={item.color}>
                <i className="material-icons">
                  { item.icon }
                </i>
              </div>
              <div className="navbar-dropdown-menu__item__text">
                { item.name }
              </div>
            </div>
          </Link>
        })
      }
    </div>
  )
}

export default NavBarDropDownMenu
